module.exports = __webpack_public_path__ + "static/media/NegativeDot.bebfa06d.svg";